import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { faqs } from '../../data/faqs';
import { container, focusRing } from '../../utils/styles';
import { FaqAccordion } from '../shared/FaqAccordion';
import { SectionHeading } from '../shared/SectionHeading';
export function FaqPreview() {
  const {
    t
  } = useLanguage();
  return <section className="bg-white py-20 sm:py-24" aria-labelledby="faq-preview-heading" data-id="element-20" data-mp="202yzdn89t4aj">
      <div className={`${container} grid gap-10 lg:grid-cols-12 lg:gap-16`} data-id="element-21" data-mp="1v68kh387ceqp">
        <div className="lg:col-span-4" data-id="element-22" data-mp="1qdyyfya7jytp">
          <SectionHeading id="faq-preview-heading" title={t({
          en: 'Common Questions',
          es: 'Preguntas Frecuentes'
        })} intro={t({
          en: 'Quick answers for families exploring home care for the first time.',
          es: 'Respuestas rápidas para familias que exploran el cuidado en el hogar por primera vez.'
        })} data-id="element-23" data-mp="1qcnrxqpdocyw" />
          <Link to="/faq" className={`mt-6 inline-flex items-center gap-2 rounded font-semibold text-brand hover:underline ${focusRing}`} data-id="element-24" data-mp="39aqmdqr54xwn">
            {t({
            en: 'See all questions',
            es: 'Ver todas las preguntas'
          })}
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-25" data-mp="2zjceaul4iprw" />
          </Link>
        </div>
        <div className="lg:col-span-8" data-id="element-26" data-mp="34guqctuftl44">
          <FaqAccordion items={faqs.filter(f => f.preview)} data-id="element-27" data-mp="2qj62re8zjzvd" />
        </div>
      </div>
    </section>;
}